// extracted by mini-css-extract-plugin
module.exports = {"Form":"Registration_Form__2ywrM"};